
const QuoteInstructions = (props) => {
    return (
        <div className='quote-instruction-container'>
            <div className='section-title'>
                <h2>
                    <span className='section-title-text'>{props.RequestAQuoteInstructions[0]}</span>
                </h2>
            </div>
            <ul className='request-a-quote-instructions'>
                <li>
                    <div className="quote-icon">
                        <i className='fa-regular fa-share-from-square'></i>
                    </div>
                    <div className="quote-text">
                        <strong>1. {props.RequestAQuoteInstructions[1]}</strong>
                        <br></br>
                        <p>{props.RequestAQuoteInstructions[2]}</p>
                    </div>
                </li>
                <li>
                    <div className="quote-icon">
                        <i className='fa-solid fa-magnifying-glass'></i>
                    </div>
                    <div className="quote-text">
                        <strong>2. {props.RequestAQuoteInstructions[3]}</strong>
                        <br></br>
                        <p>{props.RequestAQuoteInstructions[4]}</p>
                    </div>
                </li>
                <li>
                    <div className="quote-icon">
                        <i className='fa-regular fa-comments'></i>
                    </div>
                    <div className="quote-text">
                        <strong>3. {props.RequestAQuoteInstructions[5]}</strong>
                        <br></br>
                        <p>{props.RequestAQuoteInstructions[6]}</p>
                    </div>
                </li>
            </ul>
        </div>
    );
};

export default QuoteInstructions;